import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconHeadphones$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHeadphones extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a35674a3941c92f2267d951dd9eb7336ede5f452', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '50bf43cf926327675c88e3aabe26f276f579cdd5', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a3fd0234067f18b28f422ce07a70c8921de46dd4', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.25 11.636C16.234 8.138 14.21 5.75 11 5.75s-5.234 2.388-5.25 5.886h.875c.483 0 .875.428.875.955v4.455c0 .526-.392.954-.875.954h-1.75C4.392 18 4 17.572 4 17.046v-5.41C4.016 7.436 7.146 4 11 4s6.984 3.436 7 7.636v5.41c0 .526-.392.954-.875.954h-1.75c-.483 0-.875-.428-.875-.954V12.59c0-.527.392-.955.875-.955z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-headphones", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-headphones"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-headphones":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHeadphones$1);
            }
            break;
    } });
}

const CosmosIconHeadphones = CosmosIconHeadphones$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHeadphones, defineCustomElement };
